import React from "react";
import { Item } from "./Yuyue";
import styles from "../css/Yuyue.css";
import { Header } from "./Introduce";
import { Button, Toast } from "antd-mobile";
import { request } from "../request";
import {
  checkPhone,
  checkEmail,
  checkZE,
  checkChineseP,
  checkNum,
} from "../tools/wechatBrower";

// function setValue(name, value) {
//   document.getElementById(name).value = value;
// }

export default class extends React.Component {
  state = {
    model: false,
    data: {
      company_address: "",
    },
    display: false,
    ketilaiyuan: false,
    topic_leader: "",
    topic_source: "",
    topic_name: "",
  };

  componentDidMount() {
    request(
      "index/getInfo",
      {
        uid: localStorage.getItem("openid"),
      },
      ({ data }) => {
        // eslint-disable-next-line
        if (data.data.topic_source) {
          this.state.ketilaiyuan = true;
        }
        if (data.code !== 0) {
          this.setState({
            data: data.data,
            model: true,
          });
        }
      }
    );
  }

  name(e) {
    console.log(e, "~~~");
    this.state.data.name = e;
    this.setState({
      data: this.state.data,
    });
  }

  phone(e) {
    console.log(e, "~~~");
    this.state.data.phone = e;
    this.setState({
      data: this.state.data,
    });
  }

  email(e) {
    console.log(e, "~~~");
    this.state.data.email = e;
    this.setState({
      data: this.state.data,
    });
  }

  company_name(e) {
    console.log(e, "~~~");
    this.state.data.company_name = e;
    this.setState({
      data: this.state.data,
    });
  }
  company_address(e) {
    console.log(e, "~~~");
    this.state.data.company_address = e;
    this.setState({
      data: this.state.data,
    });
  }

  getId(name) {
    return document.getElementById(name).value;
  }

  topic_source(e) {
    // eslint-disable-next-line
    this.state.data.topic_source = e.target.value;
  }

  /**
   * 课题信息
   * @returns
   */
  subject_information() {
    return (
      <div className={styles.info}>
        <div className={styles.head}>
          <span className={styles.title}>课题信息</span>
        </div>
        <Item
          left="* 课题(经费)负责人"
          rightP="请输入课题负责人"
          id="topic_leader"
          onBlur={(e) => {
            if (!checkZE(this.state.data.topic_leader)) {
              Toast.fail("课题负责人只允许中英文,最多十个字");
              return;
            }
          }}
          value={this.state.data.topic_leader}
          onChange={(e) => {
            this.state.data.topic_leader = e;
            this.setState();
          }}
        ></Item>
        <Item
          left="* 课题名称"
          rightP="请输入课题名称"
          id="topic_name"
          value={this.state.data.topic_name}
          onChange={(e) => {
            this.state.data.topic_name = e;
            this.setState();
          }}
        ></Item>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <label className={styles.font}>* 课题来源</label>
          <label
            className={styles.font}
            style={{
              color: "#ae5cc9",
              display: this.state.ketilaiyuan && "none",
            }}
            onClick={() => {
              this.setState({
                ketilaiyuan: true,
              });
            }}
          >
            请选择
          </label>
        </div>
        {this.state.ketilaiyuan && (
          <div
          style={{
            display: "flex",
            flexDirection: "row",
            flexWrap: "wrap",
            marginLeft: "20px"
        }}
            onChange={(e) => {
              this.topic_source(e);
            }}
          >
            <label className={styles.font} style={{width: '50%'}}>
              <input
                name="Fruit"
                type="radio"
                value="国家重大研发计划"
                defaultChecked={
                  this.state.data.topic_source === "国家重大研发计划"
                }
              />
              国家重大研发计划{" "}
            </label>
            <label className={styles.font} style={{width: '50%'}}>
              <input
                name="Fruit"
                type="radio"
                value="重大军工项目"
                defaultChecked={this.state.data.topic_source === "重大军工项目"}
              />
              重大军工项目{" "}
            </label>
            <label className={styles.font}  style={{width: '50%'}}>
              <input
                name="Fruit"
                type="radio"
                value="科技支撑计划"
                defaultChecked={this.state.data.topic_source === "科技支撑计划"}
              />
              科技支撑计划{" "}
            </label>
            <label className={styles.font} style={{width: '50%'}}>
              <input
                name="Fruit"
                type="radio"
                value="国家产学研项目"
                defaultChecked={
                  this.state.data.topic_source === "国家产学研项目"
                }
              />
              国家产学研项目{" "}
            </label>
            <label className={styles.font} style={{width: '50%'}}>
              <input
                name="Fruit"
                type="radio"
                value="国家自然科学基金"
                defaultChecked={
                  this.state.data.topic_source === "国家自然科学基金"
                }
              />
              国家自然科学基金{" "}
            </label>
            <label className={styles.font} style={{width: '50%'}}>
              <input
                name="Fruit"
                type="radio"
                value="其他来源"
                defaultChecked={this.state.data.topic_source === "其他来源"}
              />
              其他来源{" "}
            </label>
          </div>
        )}
      </div>
    );
  }

  render() {
    return (
      <div style={{ paddingBottom: "1rem" }}>
        <Header text="个人信息"></Header>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
          }}
        >
          <div className={styles.info}>
            <Item
              left="* 姓名"
              rightP="请输入姓名"
              id="name"
              value={this.state.data.name}
              onChange={(e) => {
                this.name(e);
              }}
              onBlur={(e) => {
                if (!checkZE(this.state.data.name)) {
                  Toast.fail("姓名只允许中英文,最多二十个字");
                  return;
                }
              }}
            ></Item>

            <Item
              left="* 联系电话"
              rightP="请输入联系电话"
              id="phone"
              value={this.state.data.phone}
              onChange={(e) => {
                if (checkNum(e)) {
                  this.phone(e);
                }
              }}
              onBlur={(e) => {
                let is_phone = checkPhone(this.getId("phone"));
                if (!is_phone) {
                  Toast.fail("手机号格式不正确");
                  return;
                }
              }}
            ></Item>
            <Item
              left="* 电子邮箱"
              rightP="请输入电子邮箱"
              id="email"
              value={this.state.data.email}
              onChange={(e) => {
                this.email(e);
              }}
              onBlur={(e) => {
                console.log(
                  "this.state.data.email",
                  this.state.data.email.length
                );
                if (!checkEmail(this.state.data.email)) {
                  Toast.fail("邮箱格式不正确");
                  return;
                }
                if (this.state.data.email.length > 40) {
                  Toast.fail("邮箱最多40个字符");
                  return;
                }
              }}
            ></Item>
            <Item
              left="* 所在单位"
              rightP="请输入所在单位"
              id="company_name"
              value={this.state.data.company_name}
              onChange={(e) => {
                this.company_name(e);
              }}
              onBlur={(e) => {
                if (!checkChineseP(this.state.data.company_name)) {
                  Toast.fail("所在单位只允许中文或者括号");
                  return;
                }
              }}
            ></Item>
            <Item
              left="单位通信地址"
              rightP="请输入单位通信地址"
              id="company_address"
              value={this.state.data.company_address}
              onChange={(e) => {
                this.company_address(e);
              }}
            ></Item>
          </div>
        </div>

        {this.subject_information()}

        <Button
          type="primary"
          style={{
            width: "88%",
            backgroundColor: "#AE5CC9",
            // height: "38px",
            borderRadius: "23px",
            border: "1px solid #AE5CC9",
            margin: "1rem auto",
            marginBottom: "0px",
          }}
          onClick={() => {
            if (
              this.state.data.name &&
              this.state.data.phone &&
              this.state.data.email &&
              this.state.data.company_name &&
              this.state.data.topic_source &&
              // this.state.data.company_address &&
              this.state.data.topic_name &&
              this.state.data.topic_leader
            ) {
              console.log(1);
            } else {
              Toast.fail("所有选项不得为空");
              return;
            }

            if (!checkZE(this.state.data.name)) {
              Toast.fail("姓名只允许中英文,最多二十个字");
              return;
            }

            if (!checkPhone(this.state.data.phone)) {
              Toast.fail("手机号格式不正确");
              return;
            }
            if (!checkEmail(this.state.data.email)) {
              Toast.fail("邮箱格式不正确");
              return;
            }
            if (this.state.data.email.length > 40) {
              Toast.fail("邮箱最多40个字符");
              return;
            }

            if (!checkChineseP(this.state.data.company_name)) {
              Toast.fail("所在单位只允许中文");
              return;
            }

            if (!checkZE(this.getId("topic_leader"))) {
              Toast.fail("课题负责人只允许中英文,最多十个字");
              return;
            }

            request(
              "index/createInfo",
              {
                uid: localStorage.getItem("openid"),
                name: this.state.data.name,
                phone: this.state.data.phone,
                email: this.state.data.email,
                company_name: this.state.data.company_name,
                company_address: this.state.data.company_address
                  ? this.state.data.company_address
                  : "",
                topic_leader: this.state.data.topic_leader,
                topic_name: this.state.data.topic_name,
                topic_source: this.state.data.topic_source,
              },
              ({ data }) => {
                if (data.code === 1) {
                  this.props.history.push("/my/");
                } else {
                  Toast.fail("个人信息创建失败");
                }
              },
              (err) => {
                Toast.fail("接口错误：" + err);
              }
            );

            this.setState({
              page: 2,
            });
          }}
        >
          {this.state.model ? "保存" : "提交"}
        </Button>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/Info.js